import { Component, OnDestroy, OnInit } from '@angular/core';
import { ExperienceManager } from '../../managers/experience.manager';
import { ActivatedRoute } from '@angular/router';
import { FileManager } from '../../managers/file.manager';
import { Observable, share } from 'rxjs';
import { FileRecord } from '../../models/ui/file.model';
import { LifeCycle } from '../../models/lifecycle.model';
import { BaseComponent } from '../base.component';

@Component({
    selector: 'lex-download',
    templateUrl: './download.component.html',
    styleUrls: ['./download.component.scss'],
    standalone: false
})
export class DownloadComponent extends BaseComponent implements OnInit, OnDestroy {
	public LifeCycle = LifeCycle;
	public fileDetails$: Observable<FileRecord>;
	public sharedId: string;

	constructor(
		private experienceManager: ExperienceManager,
		private fileManager: FileManager,
		private activatedRoute: ActivatedRoute
	) {
		super();

		this.sharedId = this.activatedRoute.snapshot.params['id'];
		this.fileDetails$ = this.fileManager.getSharedFileDetails(this.sharedId).pipe(share());
		this.experienceManager.updateState({showTopBar: false})
	}

	ngOnInit(): void {
		this.experienceManager.updateState({
			showTopBar: false
		});
	}

	ngOnDestroy(): void {
		this.experienceManager.updateState({
			showTopBar: true
		});
	}

	public download() {
		this.fileManager.getSharedFileUrl(this.sharedId).subscribe((url) => {
			if (url) {
				window.open(url, '_blank');
			}
		});
	}

}
